import APIClient from '@/shared/http/clients/api'

const resourceName = 'CursosNR'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetCursosNR = (apr, revisao, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetCursosNR/${apr}/${revisao}`, data, config)

const CoursesRepository = {
  GetCursosNR
}

export default CoursesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/coursesNR.js